<template>
    <main class="main-content">
        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                    <h6 class="card-title d-print-none">نمایش پروژه</h6>
                    <div class="row" v-if="project">
                      <div class="border p-2">عنوان پروژه: {{project.name}}</div>
                      <div class="border p-2">نام مشتری: {{project.customer.name}}</div>
                      <div class="border p-2">شماره مشتری: {{project.customer.mobile}}</div>
                    </div>
                </div>
                <ul class="nav nav-tabs d-print-none" id="myTab" role="tablist">
                    <li class="nav-item">
                      <button :class="[ {'active text-white bg-dark':pageNav=='material'},'nav-link']"
                      @click="pageNav='material'">
                      متریال
                      </button>
                    </li>
                    <li class="nav-item" >
                      <button :class="[ {'active text-white bg-dark':pageNav=='gallery'},'nav-link']"
                      @click="pageNav='gallery'">
                      گالری
                      </button>
                    </li>
                    <li class="nav-item">
                      <button :class="[ {'active text-white bg-dark':pageNav=='manager'},'nav-link']"
                      @click="pageNav='manager'">
                      مدیرپروژه
                      </button>
                    </li>
                    <li class="nav-item">
                      <button :class="[ {'active text-white bg-dark':pageNav=='visitor'},'nav-link']"
                      @click="pageNav='visitor'">
                      بازدیدکننده
                      </button>
                    </li>
                    <li class="nav-item">
                      <button :class="[ {'active text-white bg-dark':pageNav=='status'},'nav-link']"
                      @click="pageNav='status'">
                      وضعیت</button>
                    </li>
                    <li class="nav-item">
                      <button :class="[ {'active text-white bg-dark':pageNav=='information'},'nav-link']"
                      @click="pageNav='information'">
                      اطلاعات</button>
                    </li>
                     <li class="nav-item">
                      <button :class="[ {'active text-white bg-dark':pageNav=='dailyReport'},'nav-link']"
                      @click="pageNav='dailyReport'">
                      گزارش روزانه
                      </button>
                    </li>
                    <li class="nav-item">
                      <button :class="[ {'active text-white bg-dark':pageNav=='managerReport'},'nav-link']"
                      @click="pageNav='managerReport'">
                      گزارش مدیر
                      </button>
                    </li>
                    <li class="nav-item">
                     <button :class="[ {'active text-white bg-dark':pageNav=='files'},'nav-link']"
                      @click="pageNav='files'">
                      فایل
                      </button>
                    </li>
                    <li class="nav-item">
                      <button :class="[ {'active text-white bg-dark':pageNav=='tickets'},'nav-link']"
                      @click="pageNav='tickets'">
                      تیکت
                      </button>
                    </li>
                    <li class="nav-item">
                     <button :class="[ {'active text-white bg-dark':pageNav=='map'},'nav-link']"
                      @click="pageNav='map'">
                      نقشه
                      </button>
                    </li>
                </ul>
                <div class="tab-content mt-3" id="myTabContent">
                   <material v-if="pageNav=='material'"
                   :data="data" :properties="properties" :materials="materials"
                   :product="product" :statuses="statuses" :installers="installers"
                   :property_default="property_default"
                   class="nav-link"/>
                   <gallery v-if="pageNav=='gallery'" :images="images"/>
                   <manager v-if="pageNav=='manager'" :users="managers" :project="project"/>
                   <visitor v-if="pageNav=='visitor'" :users="visitors" :project="project"/>
                   <status v-if="pageNav=='status'" :statuses="pstatuses" :project="project"/>
                   <information v-if="pageNav=='information'" :options="options" :projectData="project" :customerData="project.customer"/>
                   <daily v-if="pageNav=='dailyReport'" :data="dailyRepots"/>
                   <managerReport v-if="pageNav=='managerReport'" :statuses="pstatuses" :project="project" :managerReport="managerReport"/>
                   <files v-if="pageNav=='files'" :files="files"/>
                   <tickets v-if="pageNav=='tickets'" :statuses="pstatuses" :project="project"/>
                   <maap v-if="pageNav=='map'" :project="project"/>
                    <!-- <router-view></router-view> -->
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import material from '@/views/projects/components/material.vue'
import gallery from '@/views/projects/components/gallery.vue'
import manager from '@/views/projects/components/manager.vue'
import visitor from '@/views/projects/components/visitor.vue'
import status from '@/views/projects/components/status.vue'
import information from '@/views/projects/components/information.vue'
import daily from '@/views/projects/components/dailyReport.vue'
import managerReport from '@/views/projects/components/manager-report.vue'
import tickets from '@/views/projects/components/tickets.vue'
import files from '@/views/projects/components/files.vue'
import maap from '@/views/projects/components/map.vue'

export default {
  name: 'ProjectShow',
  components: {
    material,
    gallery,
    manager,
    visitor,
    status,
    information,
    daily,
    managerReport,
    files,
    tickets,
    maap
  },
  data () {
    return {
      pageNav: 'material',
      id: null,
      material: true,
      data: null,
      properties: null,
      materials: null,
      product: null,
      statuses: null,
      installers: null,
      property_default: null,
      images: null,
      managers: null,
      visitors: null,
      project: null,
      pstatuses: null,
      options: null,
      dailyRepots: null,
      managerReport: null,
      files: null
    }
  },
  beforeCreate () {
    this.id = this.$route.params.id
    this.$send.submit('get', 'api/project/get/' + this.$route.params.id)
  },
  created () {
    this.startMaterial()
    this.startGallery()
    this.getManagers()
    this.getVisitors()
    this.getProject()
    this.getProjectsStatuses()
    this.getWayForFamiliarity()
    this.startDailyReport()
    this.startManagerReport()
    this.getFiles()
  },
  methods: {
    startMaterial () {
      this.$send.submit('get', 'api/project/' + this.$route.params.id)
        .then(response => {
          this.data = response.attributes
          this.properties = response.properties
          this.materials = response.materials
          this.statuses = response.statuses
          this.installers = response.installers
          this.property_default = response.property_default
          this.images = response.images
        })
    },
    startGallery () {
      this.$send.submit('get', 'api/project/gallery/' + this.$route.params.id)
        .then(response => {
          this.images = response
        })
    },
    getUsers () {
      this.$send.submit('get', 'api/project/getUsers')
        .then(response => {
          this.users = response
        })
    },
    getProject () {
      this.$send.submit('get', 'api/project/get/' + this.$route.params.id)
        .then(response => {
          this.project = response
        })
    },
    getProjectsStatuses () {
      this.$send.submit('get', 'api/project/colors')
        .then(response => {
          this.pstatuses = response
        })
    },
    getWayForFamiliarity () {
      this.$send.submit('get', 'api/projects/create')
        .then(response => {
          this.options = response
        })
    },
    startDailyReport () {
      this.$send.submit('get', 'api/project/daily-report/' + this.$route.params.id)
        .then(response => {
          this.dailyRepots = response
        })
    },
    startManagerReport () {
      this.$send.submit('get', 'api/project/get/materials/' + this.$route.params.id)
        .then(response => {
          this.managerReport = response
        })
    },
    getFiles () {
      this.$send.submit('get', '/api/project/files/' + this.$route.params.id)
        .then(response => {
          this.files = response
        })
    },
    getManagers () {
      this.$send.submit('get', 'api/project/getManagers')
        .then(response => {
          this.managers = response
        })
    },
    getVisitors () {
      this.$send.submit('get', 'api/project/getVisitors')
        .then(response => {
          this.visitors = response
        })
    }
  }
}
</script>
<style>
  .tr {
    line-height: 100px;
    min-height: 100px;
    height: 100px;
  }

</style>
